import React, { useEffect, useState } from "react";
import ReactConfetti from "react-confetti";
import { useWindowSize } from "react-use";
import { motion, AnimatePresence } from "framer-motion";
import { Coins, Star, Trophy } from "lucide-react";

export const MissionCelebration = ({ mission, onDone }) => {
  const { width, height } = useWindowSize();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (mission) {
      setVisible(true);
      const t = setTimeout(() => { setVisible(false); onDone && onDone(); }, 2600);
      return () => clearTimeout(t);
    }
  }, [mission, onDone]);

  if (!mission) return null;

  return (
    <AnimatePresence>
      {visible && (
        <>
          <ReactConfetti
            width={width}
            height={height}
            numberOfPieces={260}
            recycle={false}
            gravity={0.22}
            colors={["#FFD700", "#FFC107", "#E63946", "#FFFFFF", "#FFE76A"]}
            style={{ position: "fixed", top: 0, left: 0, zIndex: 60, pointerEvents: "none" }}
          />
          <motion.div
            initial={{ opacity: 0, scale: 0.7, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: -10 }}
            transition={{ type: "spring", stiffness: 260, damping: 22 }}
            className="fixed top-20 left-1/2 -translate-x-1/2 z-[70] eigoo-glass rounded-3xl px-8 py-6 eigoo-glow-gold pointer-events-none"
            data-testid="mission-celebration"
          >
            <div className="flex items-center gap-4">
              <div className="h-14 w-14 rounded-2xl bg-gradient-to-br from-yellow-300 to-yellow-600 flex items-center justify-center">
                <Trophy className="text-black" size={28} />
              </div>
              <div>
                <div className="text-[11px] uppercase tracking-[0.3em] text-yellow-300/90 font-display">Mission Complete</div>
                <div className="font-display font-black text-2xl md:text-3xl leading-tight max-w-xs truncate">{mission.title}</div>
                <div className="flex items-center gap-2 mt-1">
                  <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-yellow-300 text-black text-xs font-display font-bold">
                    <Coins size={12} /> +{mission.coins}
                  </span>
                  <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-white/10 text-white text-xs font-display font-bold border border-white/15">
                    <Star size={12} /> +{mission.xp} XP
                  </span>
                </div>
              </div>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default MissionCelebration;
